import "./App.css";
import "./i18n";
import history from './history';
import { BrowserRouter, Route, Routes, } from 'react-router-dom';
import Home from './Pages/Home/Home';
import Availabilityinfo from './Pages/Availabilityinfo/Availabilityinfo';
import Camperconfiguration from './Pages/Camperconfiguration/Camperconfiguration';
import Offers from './Pages/Offers/Offers';
import Campers from './Pages/Campers/Campers';
import Campersale from './Pages/Campersale/Campersale';
import Campersubscription from './Pages/Campersubscription/Campersubscription';
import Blog from './Pages/Blog/Blog';
import Voucher from './Pages/Voucher/Voucher';
import VoucherDetails from './Pages/Voucher/VoucherDetails';
import Privacy from "./Pages/Privacy/Privacy";
import Bloginner from './Pages/Bloginner/Bloginner';
import Aboutus from './Pages/Aboutus/Aboutus';
import Contactus from './Pages/Contactus/Contactus';
import UserContactUs from './Pages/Contactus/UserContactUs';
import Configurationdetail from './Pages/Configurationdetail/Configurationdetail';
import Payment from './Pages/Payment/Payment';
import VoucherPayment from './Pages/Voucher/Payment';
import Registration from './Pages/Registration/Registration';
import Login from './Pages/Login/Login';
import Privacystatement from './Pages/Privacystatement/Privacystatement';
import Explanatoryvideo from './Pages/Explanatoryvideo/Explanatoryvideo';
import Explanatoryvideov1 from './Pages/Explanatoryvideo-v1/Explanatoryvideov1';
import Equipment from './Pages/Equipment/Equipment';
import RentConfiguration from './Pages/RentConfiguration/RentConfiguration';
import SaleAvailabilityInfo from './Pages/SaleAvailabilityInfo/SaleAvailabilityInfo';
import Userdashboard from './Pages/Userdashboard/Userdashboard';
import Thankyou from './Pages/Thankyou/Thankyou';
import Thankyouvoucher from "./Pages/Thankyou/Thankyou-voucher";
import MyOrder from './Pages/MyOrder/MyOrder';
import VideoTutorial from './Pages/VideoTutorial/VideoTutorial';
import AddTripReview from './Pages/TripReview/AddTripReview';
import SubscriptionDetail from './Pages/SubscriptionDetail/SubscriptionDetail';
import Typo from './Pages/Typo/Typo';
import Imprint from './Pages/Imprint/Imprint';
import Vouchercheckout from './Pages/Voucher/VoucherCheckout';
import Gtc from "./Pages/Gtc/Gtc";
import AvailabilityinfoSubscription from "./Pages/Configurationdetail/AvailabilityinfoSubscription";
import Tripplanner from './Pages/Tripplanner/Tripplanner';
import TripplannerSeperated from './Pages/Tripplanner/TripplannerSeperated';
import TripPlannercheckout from './Pages/Tripplanner/TripplannerCheckout';
import TripplanPayment from './Pages/Tripplanner/Payment';
import Thankyoutripplanner from './Pages/Thankyou/Thankyou-tripplanner';
import "../src/Assests/responsive.css";
import { useTranslation } from "react-i18next";
import { Helmet } from 'react-helmet';
import GTMPageView from './utils/gtmPageView';
import { captureGclid } from './utils/gclidPersist';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { SEO_CONFIG, BASE_URL, DEFAULT_SOCIAL_IMAGE, DEFAULT_TWITTER_CARD } from "./Config/seoConfig";

const normalizePathname = (pathname) => {
  if (!pathname || pathname === "/") {
    return "/";
  }

  return pathname.replace(/\/+$/, "") || "/";
};

const RouteSeo = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  const normalizedPath = normalizePathname(location.pathname);
  const routeKey =
    normalizedPath === "/campersubscription" && location.hash === "#book-your-campor"
      ? "/campersubscription#book-your-campor"
      : normalizedPath;
  const language = i18n.resolvedLanguage === "de" ? "de" : "en";
  const seoEntry = SEO_CONFIG[routeKey];

  if (!seoEntry) {
    return null;
  }

  const seo = seoEntry[language] || seoEntry.en;
  const deUrl = `${BASE_URL}${normalizedPath === "/" ? "" : normalizedPath}`;
  const enUrl = `${BASE_URL}/en${normalizedPath === "/" ? "" : normalizedPath}`;

  const canonicalUrl = language === "en" ? enUrl : deUrl;

  return (
    <Helmet htmlAttributes={{ lang: language }}>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {seo.keywords ? <meta name="keywords" content={seo.keywords} /> : null}
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hreflang="de" href={deUrl} />
      <link rel="alternate" hreflang="en" href={enUrl} />
      <link rel="alternate" hreflang="x-default" href={deUrl} />
      <meta property="og:site_name" content="Born To Camp" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content={language === "de" ? "de_DE" : "en_US"} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={DEFAULT_SOCIAL_IMAGE} />
      <meta property="og:image:secure_url" content={DEFAULT_SOCIAL_IMAGE} />
      <meta property="og:image:type" content="image/png" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="Born To Camp camper rental preview image" />
      <meta name="twitter:card" content={DEFAULT_TWITTER_CARD} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={DEFAULT_SOCIAL_IMAGE} />
      <meta name="twitter:image:alt" content="Born To Camp camper rental preview image" />
    </Helmet>
  );
};

const LanguageRedirect = ({ lang }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    localStorage.setItem("lng", lang);
    i18n.changeLanguage(lang);
    const newPath = location.pathname.replace(new RegExp(`^/${lang}`), '') || '/';
    navigate(newPath + location.search + location.hash, { replace: true });
  }, [lang, navigate, location, i18n]);

  return null;
};

function App() {

  // Capture gclid/wbraid/gbraid from landing page URL on every mount.
  // This persists the click ID through SPA navigation so it's
  // available when the purchase event fires on /thankyou.
  useEffect(() => {
    captureGclid();
  }, []);

  return (
    <div className="App">
      <BrowserRouter history={history}>
        <GTMPageView />
        <Helmet>
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        </Helmet>
        <RouteSeo />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/en" element={<Home />} />
          <Route path="/availabilityinfo/:id" element={<Availabilityinfo />} />
          <Route path="/camper-subscription/:id" element={<AvailabilityinfoSubscription />} />
          <Route path="/saleavailabilityinfo/:id" element={<SaleAvailabilityInfo />} />
          <Route path="/camperconfiguration/:id" element={<Camperconfiguration />} />
          <Route path="/rentconfiguration/:id" element={<RentConfiguration />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/campers" element={<Campers />} />
          <Route path="/campersale" element={<Campersale />} />
          <Route path="/campersubscription" element={<Campersubscription />} />
          <Route path="/tripplanner" element={<Tripplanner />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/voucher" element={<Voucher />} />
          <Route path="/voucher-detail/:id" element={<VoucherDetails />} />
          <Route path="/trip-planner-seperated" element={<TripplannerSeperated />} />
          <Route path="/tripplaner-checkout" element={<TripPlannercheckout />} />
          <Route path="/bloginner/:id" element={<Bloginner />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/voucher-checkout/:id" element={<Vouchercheckout />} />
          <Route path="/configurationdetail/:id" element={<Configurationdetail />} />
          <Route path="/subscriptiondetail/:id" element={<SubscriptionDetail />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/voucher-payment" element={<VoucherPayment />} />
          <Route path="/tripplan-payment" element={<TripplanPayment />} />
          {/* <Route path="/campervan" element={<Campervan/>}/> */}
          <Route path="/registration" element={<Registration />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacystatement" element={<Privacystatement />} />
          <Route path="/explanatoryvideo" element={<Explanatoryvideo />} />
          <Route path="/equipment" element={<Equipment />} />
          <Route path="/user-dashboard" element={<Userdashboard />} />
          <Route path="/thankyou" element={<Thankyou />} />
          <Route path="/thankyou-tripplanner" element={<Thankyoutripplanner />} />
          <Route path="/thankyou-voucher" element={<Thankyouvoucher />} />
          <Route path="/my_order" element={<MyOrder />} />
          <Route path="/video_tutorial" element={<VideoTutorial />} />
          <Route path="/user-contact-us" element={<UserContactUs />} />
          {/* <Route path="/view_document/:id" element={<ViewDocument />} /> */}
          {/* <Route path="/add_document" element={<AddDocument />} /> */}
          <Route path="/add_trip_review/:id" element={<AddTripReview />} />
          <Route path="/typo" element={<Typo />} />
          <Route path="/imprint" element={<Imprint />} />
          <Route path="/explanatoryvideov1" element={<Explanatoryvideov1 />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/gtc" element={<Gtc />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
